import { render, staticRenderFns } from "./RegistrationProduct.vue?vue&type=template&id=82ea2d90&scoped=true&"
import script from "./RegistrationProduct.vue?vue&type=script&lang=js&"
export * from "./RegistrationProduct.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationProduct.vue?vue&type=style&index=0&id=82ea2d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ea2d90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VBtn,VCol,VContainer,VRow,VSelect})
